import { Button } from "@progress/kendo-react-buttons";
import jwt_decode from "jwt-decode";
import MapContext from "../MapContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCookie } from "../../api/axios";
import Input from "./Input";
import { Error } from "@progress/kendo-react-labels";
import {
    CreateRelatedRecordData,
    UpdateRelatedRecordData,
    encodeDefaultValueRelatedRecord,
} from "./editUtils";
import { setActiveTool } from "../../redux/toolSelectSlice";
import { clearRelatedRecordEdits } from "../../redux/editingSlice";
import { getMapLayerById, getFeatureWithId } from "../utils/mapUtils";

import { makeArray } from "../../permissionUtils";

const EditRelatedRecords = () => {
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const dispatch = useDispatch();
    const { map } = useContext(MapContext);
    const currentRelatedRecordInfo = useSelector(
        (state) => state.editingOptions.currentEditRelatedRecordInfo
    );
    const currentEditRelatedRecordData = useSelector(
        (state) => state.editingOptions.currentEditRelatedRecordData
    );

    const [layer] = useSelector((state) => state.resultsData.resultsForFeature);
    const layerId = layer.Id;
    const featureId = layer.Features[0];
    // get feature from map
    const feature = getFeatureWithId(map, layerId, featureId);

    const token = getCookie("ast");
    let userGivenName = "Guest";
    let tokenRoles = ["GUEST"];
    if (token) {
        userGivenName = jwt_decode(token).preferred_username;
        tokenRoles = jwt_decode(token).realm_access.roles;
    }

    const [formValues, setFormValues] = useState([]);
    const [validationMessage, setValidationMessage] = useState();
    useEffect(() => {
        let fieldsList = makeArray(
            currentRelatedRecordInfo.relatedRecordInfo.Fields.Field
        );
        if (formValues.length === 0 && fieldsList.length > 0 && feature) {
            let val = [];
            fieldsList.map((el) => {
                if (el.Visible || el.Type?.toLowerCase() === "guid") {
                    let currentFieldVal = undefined;
                    if (currentEditRelatedRecordData.record) {
                        currentFieldVal = currentEditRelatedRecordData.record[el.Name];
                    }
                    val.push({
                        key: `input_${el.Name}`,
                        id: `input_${el.Name}`,
                        label: el.DisplayName ?? el.Name,
                        type: el.Type?.toLowerCase() ?? "string",
                        value:
                            currentFieldVal ??
                            encodeDefaultValueRelatedRecord(
                                el.DefaultValue,
                                userGivenName,
                                feature ?? undefined
                            ) ??
                            "",
                        domains: el.Domains,
                        charLimit: el.CharLimit,
                    });
                }
            });
            setFormValues(() => {
                return val;
            });
        }
    }, [formValues]);

    const back = () => {
        dispatch(clearRelatedRecordEdits());
        dispatch(setActiveTool(""));
    };

    const handleChange = (e, index) => {
        const values = [...formValues];
        values[index].value = e.target.value;
        setFormValues(values);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let attArr = formValues.map((val) => {
            let value;
            // handle falsy values (0, "", undefined, null, false) change to null
            if (val.type === "date" && val.value == false) {
                value = null;
            } else if (val.type === "date" && typeof val.value === "number") {
                value = val.value;
            } else if (val.type === "date" && typeof val.value === "object") {
                value = val.value.valueOf();
            } else if (val.type === "date" && typeof val.value === "string") {
                let temp = new Date(val.value);
                if (temp.toString() !== "Invalid Date") {
                    value = temp.valueOf();
                }
            } else {
                value = val.value;
            }
            return {
                fieldName: val.id.replace("input_", ""),
                fieldValue: value,
            };
        });
        if (currentEditRelatedRecordData.record) {
            UpdateRelatedRecordData(
                feature.id_,
                currentRelatedRecordInfo.layerInfo,
                currentRelatedRecordInfo.relatedRecordInfo,
                currentEditRelatedRecordData.record[
                    currentRelatedRecordInfo.relatedRecordInfo.PrimaryKey
                ],
                attArr,
                saveCallback
            );
        } else {
            CreateRelatedRecordData(
                feature.id_,
                currentRelatedRecordInfo.layerInfo,
                currentRelatedRecordInfo.relatedRecordInfo,
                attArr,
                saveCallback
            );
        }
    };

    const saveCallback = (evt) => {
        if (evt.error) {
            setValidationMessage(evt.error);
        } else {
            let layer = getMapLayerById(map, evt.layer.Id);
            layer.getSource().refresh();
            let layerLabel = getMapLayerById(map, evt.layer.Id + "_label")?.getSource();
            if (layerLabel) {
                layerLabel.refresh();
            }
            setValidationMessage();
            dispatch(clearRelatedRecordEdits());
            dispatch(setActiveTool(""));
        }
    };

    return (
        <>
            {" "}
            {mapConfig && (
                <>
                    <Button onClick={back} className="back-button">
                        &lt;
                    </Button>
                    <h3 className="title">
                        Create {currentRelatedRecordInfo.relatedRecordInfo.DisplayName}
                    </h3>
                    <h4>Attributes</h4>
                    <form onSubmit={handleSubmit}>
                        {formValues.map((obj, index) => (
                            <Input
                                key={index}
                                objValue={obj}
                                onChange={handleChange}
                                index={index}
                            />
                        ))}
                        {validationMessage && <Error>{validationMessage}</Error>}
                        <Button
                            title="Submit"
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success submit-button">
                            Save
                        </Button>
                    </form>
                </>
            )}
        </>
    );
};
export default EditRelatedRecords;
